import { createRouter, createWebHistory } from "vue-router";
import MainPage from "@/pages/MainPage.vue";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/ner-testing",
  },
  {
    path: "/ner-testing",
    name: "ner-testing",
    component: MainPage
  },
  {
    path: "/login",
    name: "login",
  },
  {
    path: "/lk",
    name: "lk",
  },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;